<template>
  <div class="create-form">
    <div class="acivity-right">
      <el-form :inline="true" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="110px">
        <el-form-item label="活动名称：">
          {{ formInline.name }}
        </el-form-item>
        <el-form-item label="活动时间：">
          {{ formInline.start_time }} -- {{ formInline.end_time }}
        </el-form-item>
        <el-form-item label="类型：">
          <span v-if="formInline.type == 0">兑换券</span>
          <span v-if="formInline.type == 1">代金券</span>
        </el-form-item>
        <el-form-item label="兑换产品：">
          {{ formInline.products }}
        </el-form-item>
        <el-form-item label="代金券金额：" v-if="type === 1">
          {{ formInline.money_min }}&nbsp;- &nbsp;{{ formInline.money_max }}
        </el-form-item>
        <el-form-item label="投放数量：" prop="put_number">
          {{ formInline.put_number }} 张
        </el-form-item>
        <el-form-item label="领取规则：">
          每人限领 {{ formInline.receivenum }} 张，0代表不限制
        </el-form-item>
        <el-form-item label="使用时间：">
          <span v-if="formInline.validitytype == 0">当日生效</span>
          <span v-if="formInline.validitytype == 1">次日生效</span>
          <br/>
          有效天数：
          {{ formInline.validitydays }} 天，0代表有效期至活动结束
        </el-form-item>
        <el-form-item label="使用数量：">
          每店每日限核销：{{ formInline.storeusenum }} 张
          <br />
          每店每日限核销：{{ formInline.storeusemoney }} 元
          <br />
          &nbsp;&nbsp;&nbsp; 每人每日限用：{{ formInline.usenum }} 张
          <br />
          &nbsp;&nbsp;&nbsp; 每人每日限用：{{ formInline.usemoney }} 元
        </el-form-item>
        <el-form-item label="使用范围：" prop="rangegroup">
          <el-select filterable v-model="formInline.rangegroup" disabled  placeholder="请选择">
            <el-option v-for="item in rangegroups" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用区域：" >
          <template>
            <el-cascader disabled size="large" :options="options" v-model="selectedOptions"  @change="handleChange">
            </el-cascader>
          </template>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { API_HOST, API_HOST_JAVA_SET } from '@/api/local'
import { regionDataPlus, CodeToText } from 'element-china-area-data'
import { getGroups, getCouponsDetail } from '@/api/yunzhong.js'
export default {
  name: 'edit-coupons',
  data() {
    return {
      id: 0,
      options: regionDataPlus, //区域
      selectedOptions: [],
      rangegroups: [],
      typeOptions: [
        {
          value: 0,
          label: '兑换券'
        },
        {
          value: 1,
          label: '代金券'
        }
      ],
      type: 0,
      formInline: {
        name: '',
        date: [],
        start_time: '',
        end_time: '',
        type: 0,
        products: '',
        money_min: 0,
        money_max: 0,
        receivenum: 0,
        validitytype: null,
        validitydays: 0,
        storeusenum: 0,
        storeusemoney: 0,
        usenum: 0,
        usemoney: 0,
        rangegroup: 0,
        province: '',
        city: '',
        district: '',
        put_number: 0,
      },
      rules: {
        activity_type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入投放数量', trigger: 'blur' }
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      pickerAppointedOptions: {
        disabledDate: (time) => {
          let _this = this
          let start = new Date(Date.parse(_this.formInline.start_time.replace(/-/g, '/')))
          let end = new Date(Date.parse(_this.formInline.end_time.replace(/-/g, '/')))
          return !((time.getTime() >= start) && (time.getTime() <= end))
        }
      },
    }
  },
  methods: {
    getData() {
      let self = this
      self.id = self.$route.query.id
      getCouponsDetail(self.id).then(res => {
        self.formInline = JSON.parse(JSON.stringify(res.data.data))
        //self.formInline.date = [self.formInline.start_time, self.formInline.end_time]
        self.selectedOptions =[self.formInline.province ? self.formInline.province : '', self.formInline.city ? self.formInline.city : '', self.formInline.district ? self.formInline.district : '']
        this.type = self.formInline.type
      })
    },
    typeChange(v){
      this.type = v
    },
    handleChange(value){
      //console.log(value)
      this.formInline.province = value[0]
      this.formInline.city = value[1]
      this.formInline.district = value[2]
    },
    dateChange(value) {
      console.log(value)
      if (value) {
        this.formInline.start_time = value[0]
        this.formInline.end_time = value[1]
      } else {
        this.formInline.start_time = ''
        this.formInline.end_time = ''
      }
    },
    // 获取群组
    getGroupList() {
      getGroups().then((res) => {
        if(res.data.code == 200) {
          for (let item of res.data.result.list) {
            this.rangegroups.push({
              label: item.name,
              value: item.id
            })
          }
        }
        else{
          console.log(res.data.error)
        }
        this.getData()
      })
    }
  },
  created() {
    this.getGroupList()
  }
}

</script>
<style scoped>
.el-form-item{display: block}
.create-form {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: calc(100% - 40px);
  background: #fff;
  margin: 20px auto 0;
  overflow-x: hidden;
}
.acivity-right {
  margin: 20px auto;
  width: 100%;
  align-items: center;
  display: block;
  justify-content: center;
}
.inputwidth{
  width: 370px;
}
.acivity-content-form {
  width: 534px;
  text-align: left;
  margin: auto;
}

.acivity-content-form .el-form-item__content {
  width: 300px;
}

.acivity-content-form p {
  margin: 0px;
  line-height: 20px;
  text-align: left;
  color: #999;
  font-size: 12px;
}
.x_input{
  width:172px!important;
}

</style>
